import React from 'react';
export function Footer() {
  return <footer className="py-12 md:py-16 border-t border-[#E8D5C4] bg-[#F4EDE4]" data-id="element-17">
      <div className="max-w-4xl mx-auto px-4 text-center" data-id="element-18">
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white border border-[#E8D5C4] text-[#5A2A3D] text-xs font-bold tracking-[0.25em] mb-6 uppercase" data-id="element-19">
          Kit Lashista™
        </div>

        <p className="text-[#2D1A22] font-medium text-base md:text-lg mb-2" style={{
        fontFamily: "'DM Serif Display', serif"
      }} data-id="element-20">
          El sistema N°1 para lashistas argentinas que quieren{' '}
          <span className="italic" data-id="element-21">una agenda que respetan</span>.
        </p>
        <p className="text-[#5A4A4F] text-sm md:text-base mb-10 italic" data-id="element-22">
          Porque tener la técnica perfecta no alcanza si tus clientas no
          aparecen.
        </p>

        <div className="flex flex-col md:flex-row items-center justify-center gap-3 md:gap-6 text-sm text-[#5A4A4F] mb-10" data-id="element-23">
          <a href="mailto:soportenexorecursos@gmail.com" className="hover:text-[#5A2A3D] transition-colors" data-id="element-24">
            📧 soportenexorecursos@gmail.com
          </a>
          <span className="hidden md:inline text-[#E8D5C4]" data-id="element-25">|</span>
          <a href="https://lashista.nexorecursos.com" target="_blank" rel="noopener noreferrer" className="hover:text-[#5A2A3D] transition-colors" data-id="element-26">
            🌐 lashista.nexorecursos.com
          </a>
        </div>

        <div className="text-[#5A4A4F] text-xs md:text-sm space-y-1 mb-12" data-id="element-27">
          <p data-id="element-28">
            © Kit Lashista Tu Agenda Profesional™ 2025 — Todos los derechos
            reservados.
          </p>
          <p data-id="element-29">
            Prohibida la reproducción y redistribución sin autorización expresa.
          </p>
        </div>

        <div className="pt-8 border-t border-[#E8D5C4] max-w-2xl mx-auto" data-id="element-30">
          <p className="text-[#5A2A3D] italic font-medium text-base md:text-lg leading-relaxed" style={{
          fontFamily: "'DM Serif Display', serif"
        }} data-id="element-31">
            "Tu agenda profesional no es un sueño. Es un sistema. El sistema
            está acá. Solo falta que lo enciendas."
          </p>
        </div>
      </div>
    </footer>;
}